import { resizeImage } from "@/lib/crop-utils";
import { gameService } from "@/services/game.service";

const RESIZE_OPTIONS = {
  maxWidth: 1600,
  maxHeight: 1600,
  quality: 0.85,
} as const;

export function filterImageFiles(files: FileList | File[] | null | undefined): File[] {
  if (!files) return [];
  return Array.from(files).filter((file) => file.type.startsWith("image/"));
}

export async function uploadGameGalleryPhotos(
  gameId: string,
  files: File[],
  onProgress?: (done: number, total: number) => void,
): Promise<{ uploaded: number; failed: number }> {
  let uploaded = 0;
  let failed = 0;

  for (let i = 0; i < files.length; i++) {
    try {
      const resized = await resizeImage(files[i], RESIZE_OPTIONS);
      await gameService.uploadGalleryPhoto(gameId, resized);
      uploaded++;
    } catch {
      failed++;
    }
    onProgress?.(i + 1, files.length);
  }

  return { uploaded, failed };
}
